import { render } from "./NcrmRecordDeleteDialog.vue?vue&type=template&id=8c9a317c"
import script from "./NcrmRecordDeleteDialog.vue?vue&type=script&lang=js"
export * from "./NcrmRecordDeleteDialog.vue?vue&type=script&lang=js"

import "./NcrmRecordDeleteDialog.vue?vue&type=style&index=0&id=8c9a317c&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__